/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from 'relay-runtime';
declare export opaque type collectionList_viewer$ref: FragmentReference;
export type collectionList_viewer = {|
  +id: string,
  +collections: ?{|
    +total: ?number,
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +description: ?string,
        +name: string,
        +slug: ?string,
        +category: ?{|
          +id: string,
          +name: ?string,
        |},
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
        +tracks: ?$ReadOnlyArray<?{|
          +id: string,
        |}>,
      |},
    |}>,
  |},
  +collection_categories: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: ?string,
      |},
    |}>,
  |},
  +$refType: collectionList_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "collectionList_viewer",
  "type": "Viewer",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "collections"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "collection_categories"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    v0,
    {
      "kind": "LinkedField",
      "alias": "collections",
      "name": "__list_collections_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "CollectionConnection",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "total",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CollectionEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Collection",
              "plural": false,
              "selections": [
                v0,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                },
                v1,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "slug",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "category",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CollectionCategory",
                  "plural": false,
                  "selections": [
                    v0,
                    v1
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "assets",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Asset",
                  "plural": true,
                  "selections": [
                    v0,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "version",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "type",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "file_format",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "path",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "metadata",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "tracks",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Track",
                  "plural": true,
                  "selections": [
                    v0
                  ]
                },
                v2
              ]
            },
            v3
          ]
        },
        v4
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "collection_categories",
      "name": "__list_collection_categories_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "CollectionCategoryConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CollectionCategoryEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "CollectionCategory",
              "plural": false,
              "selections": [
                v0,
                v1,
                v2
              ]
            },
            v3
          ]
        },
        v4
      ]
    }
  ]
};
})();
(node/*: any*/).hash = '2fcc550fc42ee3e2cec2bc95589f8d07';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/collectionList_viewer.graphql.js